import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Tooltip from "@mui/material/Tooltip";

import { checkViewerRole } from "common/checkers/viewerChecker";
import styles from "./addNotes.module.scss";
import { BtnType, Button, TextBox } from "../../../../../primitives";
import { initModel, validation } from "../taskInfo.constants";
import {
  projectTaskNotesAdd,
  projectTaskNotesUpdate,
} from "../../tasks.action";

const AddNotesComponent = (props) => {
  const { assignmentId, selectedNote = null } = props;

  const { enqueueSnackbar } = useSnackbar();
  const formRef = useRef();
  const [model, setModel] = useState(initModel);
  const [formKey, setFormKey] = useState(Math.random());
  const [blockFunctionality, setBlockFunctionality] = useState(false);

  useEffect(() => {
    if (checkViewerRole()) {
      setBlockFunctionality(true);
    }
  }, []);
  const {
    authReducer: { session },
    projectsReducer: {
      projectReducer: { selectedProject },
    },
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedNote) setModel(selectedNote);
  }, [selectedNote]);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.resetForm();
      setFormKey(Math.random());
    }
  }, [assignmentId]);

  const handleOnSubmit = (value) => {
    const obj = {
      projectId: selectedProject.id,
      assignmentId,
      enqueueSnackbar,
      note: {
        added_by_id: session.id,
        ...value,
      },
    };
    if (value.id) {
      dispatch(projectTaskNotesUpdate(obj));
      setModel(initModel);
    } else {
      dispatch(projectTaskNotesAdd(obj));
    }
  };

  return (
    <div className={styles.noteCon}>
      <Formik
        innerRef={formRef}
        enableReinitialize
        initialValues={model && model}
        validationSchema={validation && validation}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          handleOnSubmit(values);
          resetForm();
          setFormKey(Math.random());
        }}
      >
        {({ handleSubmit, ...formikprops }) => (
          <form onSubmit={handleSubmit} key={formKey}>
            <TextBox
              type="text"
              name="description"
              placeholder="Add a note"
              className={styles.textBox}
              formProps={formikprops}
            />
            {!blockFunctionality ? (
              <Button btn={BtnType.REGULAR}>Add Note</Button>
            ) : (
              <Tooltip
                title="You have View-Only access. To Add a Note, please ask your Admin to upgrade your account to Standard access."
                placement="top"
              >
                <div>
                  <Button
                    onClick={(e) => e.preventDefault()}
                    btn={BtnType.DISABLED}
                  >
                    Add Note
                  </Button>
                </div>
              </Tooltip>
            )}
          </form>
        )}
      </Formik>
    </div>
  );
};

export default React.memo(AddNotesComponent);
